module.exports = __webpack_public_path__ + "static/media/zera_move_head.190f4bcd.gif";